export function createLfmSceneWorker(): Worker {
  return new Worker(new URL('./lfm-scene-worker.ts', import.meta.url), {
    type: 'module',
  })
}
